export default __webpack_public_path__ + "static/media/profile_fullsize.df034b14.jpg";